<template>
  <div>
    <Modal v-model="ownLogisticsChannelModal" :title="ownlogisticsChannelTitle" width="1000" class-name="ownlogisticsChannelStyle"
      :transfer="false" :mask-closable="false" @on-visible-change="ownlogisticsChannelChange">
      <!--渠道基础信息-->
      <Card :bordered="true" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005288') }}</h2>
        </template>
        <Form :label-width="labelWidth" :model="channelBasicInfo" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001579')">
                <span>{{ channelBasicInfo.languageCarrierName }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1000122')">
                <span>{{ channelBasicInfo.languageCarrierShippingMethodName }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005292')">
                <span>{{ channelBasicInfo.carrierShippingMethodCode }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="isOnline === 1">
              <Form-item :label="$t('key1005294')">
                <span>{{ getPerformanceMethodName(channelBasicInfo.performanceType) }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005296')">
                <div class="flex align-items-center">
                  <span>{{ channelBasicInfo.minEfficiency }}</span>
                  <span> - </span>
                  <span>{{ channelBasicInfo.maxEfficiency }}</span>
                  <span>{{ $t('key1001631') }}</span>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005298')">
                <div class="flex align-items-center">
                  <span>{{ channelBasicInfo.maxLength }}</span>
                  <span>*</span>
                  <span>{{ channelBasicInfo.maxWidth }}</span>
                  <span>*</span>
                  <span>{{ channelBasicInfo.maxHeight }}</span>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005391')">
                <div class="flex align-items-center">
                  <span>{{ channelBasicInfo.minWeight }}</span>
                  <span> - </span>
                  <span>{{ channelBasicInfo.maxWeight }}</span>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005300')">
                <span>{{ channelBasicInfo.maxPerimeter }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005301')">
                <span>{{ channelBasicInfo.maxDimensionsLength }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005302')">
                <div class="flex align-items-center">
                  <span>{{ channelBasicInfo.minVolume }}</span>
                  <span> - </span>
                  <span>{{ channelBasicInfo.maxVolume }}</span>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005286')">
                <span>{{ channelBasicInfo.languageRemark }}</span>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </Card>
      <!--交货方式-->
      <Card :bordered="true" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004023') }}</h2>
        </template>
        <Form :label-width="labelWidth" :model="deliveryMethodForm" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005276')">
                <span>{{ deliveryMethodForm.deliveryMethod }}</span>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-if="deliveryMethodForm.deliveryType === 1">
              <Form-item :label="$t('key1005277')">
                <div class="flex align-items-center" v-if="deliveryMethodForm.courierFee">
                  <span>{{ deliveryMethodForm.courierFee }}</span>
                  <span class="ml4">{{ currencyState + $t('key1002442') }}</span>
                </div>
              </Form-item>
            </Col>
          </Row>
          <template v-if="deliveryMethodForm.deliveryType === 1">
            <h2 class="color-333 font-weight-bold font-size-14 mt10">{{ $t('key1005304') }}</h2>
            <Row type="flex" :gutter="gutterItem" class="font-size-13 mt10" style="margin-left: 23px"
              v-if="Object.keys(deliveryMethodForm.addressDetails).length >0">
              <Col :span="24" class="basic_item" v-for="ele in addressInfoList">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" style="max-width: initial;" :title="deliveryMethodForm.addressDetails[ele.paramsKey]">
                  {{ deliveryMethodForm.addressDetails[ele.paramsKey] || '--' }}
                </span>
              </Col>
            </Row>
          </template>
        </Form>
      </Card>
      <!--派送范围及运费-->
      <Card :bordered="true" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005309') }}</h2>
        </template>
        <div class="p10 flex align-items-center">
          <p class="font-weight-bold">{{ $t('key1006458') }}</p>
          <span v-if="ownLogisticsChannelType === 'look'">
            {{ getEnumName(enumData, 'YmsLogisServiceArriveableTypeCoreEnum', arriveableType, 'number') }}
          </span>
          <RadioGroup v-model="arriveableType" v-else>
            <Radio v-for="(item,index) in sendUsageTypeList" :key="index" :label="item.value" class="ml20">
              <span>{{ item.name }}</span>
            </Radio>
          </RadioGroup>
        </div>
        <div class="p10">
          <div class="flex justify-content-between align-items-center mb10">
            <h3 class="font-weight-bold">{{ $t('key1005311') }}</h3>
            <div class="flex align-items-center" v-if="ownLogisticsChannelType !== 'look'">
<!--              <Button size="small" class="ml5" v-if="arriveableType !==1" @click="batchImport">批量导入 </Button>-->
              <Button size="small" class="ml5" v-if="arriveableType !==1" @click="addPartition">{{ $t('key1005314') }} </Button>
              <Button size="small" class="ml5" @click="channelCitation">{{ $t('key1005312') }} </Button>
            </div>
          </div>
          <Row type="flex" justify="start" :gutter="20" align="middle" v-if="currencyList.length>0">
            <Col>
              <Row type="flex" justify="start" :gutter="5" align="middle">
                <span class="redColor">*</span>
                <span class="font-weight-bold">{{ $t('key1005315') }}</span>
                <Col>
                    <span v-if="ownLogisticsChannelType === 'look'">
                      {{
                        currencyList.filter((item) => {
                          if (item.value === freightCurrency) {
                            return item
                          }
                        })[0].label || ''
                      }}</span>
                  <Select v-model="freightCurrency" filterable v-else>
                    <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row type="flex" justify="start" :gutter="5" align="middle">
                <Col>
                  <span v-if="ownLogisticsChannelType === 'look'">
                     {{ getEnumName(enumData, 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum', freightDiscountType) }}
                  </span>
                  <Select v-model="freightDiscountType" v-else>
                    <Option v-for="item in freightDiscountTypeList" :value="item.value">{{ item.name }}</Option>
                  </Select>
                </Col>
                <Col>
                  <span v-if="ownLogisticsChannelType === 'look'">{{ freightDiscount.toFixed(2) }}</span>
                  <InputNumber v-else :precision="4" :min="0" v-model="freightDiscount" :max="1"/>
                </Col>
              </Row>
            </Col>
            <Col v-if="ownLogisticsChannelType !== 'look'">
              <span class="redColor">{{ $t('key1005316') }}</span>
            </Col>
          </Row>
          <Table
            highlight-row
            border
            :columns="columns4"
            class="mt10"
            :data="data4"
            max-height="300">
          </Table>
        </div>
      </Card>
      <template #footer>
        <Button @click="ownLogisticsChannelModal = false">{{ $t('key1000248') }}</Button>
        <Button v-if="!looKsettings" @click="setShippingMethod" type="primary">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!-- 编辑/查看运费 -->
    <billingModelEditingModal
      ref="billingModelEditing"
      @saveBtn="editOK"
      :looKsettings="looKsettings"
      billingModelType="YMS"
      :freightCurrency="freightCurrency">
    </billingModelEditingModal>
    <!--批量导入 计费模型-->
    <importFreightTemplateModal ref="importFreightTemplate" @success="importFreightTemplateSuccess"></importFreightTemplateModal>
    <!--从其他渠道引用-弹窗-->
    <channelReferenceModal ref="channelReference" @saveChannel="saveChannel"></channelReferenceModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import importFreightTemplateModal from "@/components/common/importFreightTemplateModal";
import channelReferenceModal from "@/components/common/channelReferenceModal";
import billingModelEditingModal from "@/components/common/billingModelEditingModal";
import {getAllCountrysData, getCurrencyData, getDataSetBatchList, getEnumList, getEnumName, getRegionalRcountriesData, mergeByCountriesStrict, processFreightText} from "@/utils/common";
import {publicExceptionCodes} from "@/config/exceptionCode";
import {PERFORMANCEMETHODDATA} from "@/utils/enum";

export default {
  name: "ownLogisticsChannelModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      looKsettings: false,
      ownLogisticsChannelModal: false,
      ownLogisticsChannelType: 'look',
      ownlogisticsChannelTitle: '',
      arriveableType: null,
      freightCurrency: 'CNY',
      freightDiscountType: '1',
      freightDiscount: 1,
      channelBasicInfo: {
        acceptableCityList: null,
        carrierShippingMethodCode: '',
        languageCarrierShippingMethodName: '',
        minEfficiency: 0,
        maxEfficiency: 0,
        maxLength: 0,
        maxWidth: 0,
        maxHeight: 0,
        minWeight: 0,
        maxWeight: 0,
        maxPerimeter: 0,
        maxDimensionsLength: 0,
        minVolume: 0,
        maxVolume: 0,
        acceptablePackageTypeList: '',
        isSupportInterfaceTransferBill: 0,
        arriveableType: '1',
        languageRemark: ''
      }, // 渠道基础信息
      columns4: [
        {
          key: 'zoneName',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          align: 'center',
          render(h, params) {
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005240'));
            } else {
              return h('div', params.row.zoneName);
            }
          }
        }, {
          key: 'carrierShippingMethodPriceModelZoneCountryList',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          align: 'center',
          render(h, params) {
            let text = '';
            if (params.row.zoneName === '0') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005242'));
            } else {
              if (params.row.carrierShippingMethodPriceModelZoneCountryList) {
                text = params.row.carrierShippingMethodPriceModelZoneCountryList.map(i => {
                  return i.cnName;
                }).join('、');
              }
              return h('span', text);
            }
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005243'),
          align: 'center',
          render(h, params) {
            let priceType = params.row.priceType;
            let text = getEnumName(v.enumData, 'YmsLogisServicePriceModelZonePriceTypeCoreEnum', priceType, 'number');
            return h('span', text);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005244'),
          align: 'center',
          render(h, params) {
            let weightType = params.row.weightType;
            let text = getEnumName(v.enumData, 'YmsLogisServicePriceModelZoneWeightTypeCoreEnum', weightType, 'number');
            return h('span', text);
          }
        },
        {
          key: 'formula',
          align: 'center',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005245'),
          render: (h, params) => {
            return h('span', {
              domProps: {
                innerHTML: params.row.formula || ''
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 120,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                align: 'center',
                operationList: [
                  {
                    text: v.ownLogisticsChannelType === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: true,
                    clickFn: () => {
                      v.editIndex = params.index;
                      v.$refs['billingModelEditing'].initBillingModelData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: params.row.zoneName !== '0' && v.ownLogisticsChannelType !== 'look',
                    clickFn: () => {
                      v.data4.splice(params.index, 1);
                      // 全球可达（运费不同）
                      if (v.arriveableType === 2) {
                        v.data6.splice(params.index, 1);
                      }
                      // 非全球可达
                      else if (v.arriveableType === 3) {
                        v.data7.splice(params.index, 1);
                      }
                      v.data4.forEach((i, index) => {
                        if (v.arriveableType === 3) {
                          i.zoneName = index + 1 + '';
                        } else {
                          i.zoneName = index + '';
                        }
                      });
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      data4: [],
      data5: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费相同）
      data6: [
        {
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': '0',
          carrierShippingMethodPriceModelZoneCountryList: []
        }
      ], // 全球可达（运费不同）
      data7: [], // 非全球可达
      modalData: {},
      isOnline: 0, // 1 线上物流  0 线下物流
      apiInterface: '',
      pricingParams: {
        priceType: null,
        weightType: null,
        subCostWay: null
      },
      cachePricingData: [],
      pricingModelCommonColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005239'),
          key: 'name',
          minWidth: 100,
          align: 'center'
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005241'),
          key: 'reachState',
          minWidth: 150,
          maxWidth: 240,
          align: 'center',
          render: (h, params) => {
            return h('div', v.getPricingReachStateData(params.row.carrierShippingMethodPriceModelZoneCountryList));
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          key: 'costPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.price,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005231')}`
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.price * (v.freightDiscount === null ? 100 : v.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023'),
          key: 'registrationFee',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.registrationFee,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005232'),
          key: 'operatingCost',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.operatingCost,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005232')}`
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      pricingModelContinuedHeavyColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233'),
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.firstWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005233')}`
              },
              on: {
                'input': (val) => {
                  v.cachePricingData[params.index].firstWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017'),
          key: 'firstWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.firstWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017')}`
                },
                on: {
                  'input': (val) => {
                    v.cachePricingData[params.index].firstWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.firstWeightPrice * (v.freightDiscount === null
                  ? 100
                  : v.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234'),
          key: 'unitWeight',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.unitWeight,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005234')}`
              },
              on: {
                'input': (val) => {
                  v.cachePricingData[params.index].unitWeight = val;
                }
              }
            });
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005235'),
          key: 'unitWeightPrice',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  value: params.row.unitWeightPrice,
                  min: 0,
                  max: 9999999,
                  placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005235')}`
                },
                on: {
                  'input': (val) => {
                    v.cachePricingData[params.index].unitWeightPrice = val;
                  }
                }
              }), h('div', {
                class: 'flexBox normalTop flexBoxJustContent'
              }, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                  class: 'redColor'
                }, '$ ' + params.row.unitWeightPrice * (v.freightDiscount === null
                  ? 100
                  : v.freightDiscount) / 100)
              ])
            ]);
          }
        }, {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: params.row.additionalFeeRate,
                min: 0,
                max: 9999999,
                placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027')}`
              }
            });
          }
        }
      ],
      carrierShippingMethodPriceModelId: null,
      carrierShippingMethodParmas: {
        maxPrice: null,
        minPrice: 0,
        maxLength: 0,
        minLength: 0,
        maxShippingFeeIncome: null,
        minShippingFeeIncome: 0,
        minEfficiency: 0,
        maxEfficiency: 0,
        minGoodsQuantity: 0,
        maxGoodsQuantity: null
      },
      pricingModelColumns: [],
      cachePriceModelColumns: [],
      shippingMethodId: null,
      deliveryMethodForm: {
        deliveryType: null,
        courierFee: null, // 国内快递费用
        deliveryMethod: '', // 交货方式
        addressDetails: {}
      },
      countrysList: [],
      addressInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'), paramsKey: 'name'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'), paramsKey: 'countryCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'state'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'city'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'), paramsKey: 'district'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'), paramsKey: 'street'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'), paramsKey: 'street2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'), paramsKey: 'street3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002339'), paramsKey: 'phone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'postcode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'), paramsKey: 'company'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'email'},
      ],
      currencyList: [],
      countrysData: [],
      enumData: [],
    };
  },
  computed: {
    labelWidth() {
      let width = this.languagesVal === 'zh-CN' ? 120 : 240;
      return width;
    },
    freightDiscountTypeList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    },
    // 派送范围
    sendUsageTypeList() {
      const ENUM_KEY = 'YmsLogisServiceArriveableTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  methods: {
    getEnumName,
    // 初始化自有物流渠道的接口数据
    ownLogisticsChannelFun(shippingMethodId, type) {
      let v = this;
      v.ownLogisticsChannelType = type;
      v.ownlogisticsChannelTitle = type === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005256');
      v.looKsettings = type === 'look' ? true : false;
      (async () => {
        let enumKeyList = [
          'YmsLogisServicePriceModelZoneWeightTypeCoreEnum',
          'YmsLogisServicePriceModelZonePriceTypeCoreEnum',
          'YmsLogisServicePriceModelFreightDiscountTypeCoreEnum',
          'YmsLogisServiceArriveableTypeCoreEnum',
          'DeliveryTypeEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getAllCountrysData().then((data) => {
          v.countrysData = data;
          if (data.length > 0) {
            v.countrysList = data.filter((ele) => {
              return ele.twoCode === 'CN';
            });
          }
        });
        await v.getAddressTemplateData('distributor');
        await getCurrencyData().then((data) => {
          v.currencyList = data;
        });
        await v.getOwnLogisticsChannelDetails(shippingMethodId);
      })();
    },
    // 获取自有物流渠道详情的数据
    getOwnLogisticsChannelDetails(shippingMethodId) {
      let v = this;
      if (v.ownLogisticsChannelType !== 'look') {
        v.GetQuotingLogisticsData(true); // 获取从其他渠道引用的物流商数据
      }
      v.getAllCountryName(true);
      v.axios.get(api.get_ymsCarrierShippingMethod + shippingMethodId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          v.ownLogisticsChannelModal = true;
          let data = response.data.datas;
          v.channelBasicInfo = JSON.parse(JSON.stringify(data.carrierShippingMethod));
          v.shippingMethodId = data.carrierShippingMethod.shippingMethodId;
          v.modalData = data;
          v.channelBasicInfo.languageCarrierName = data.carrier.languageCarrierName;
          v.channelBasicInfo.carrierName = data.carrier.carrierName;
          v.isOnline = data.carrier.isOnline;
          v.apiInterface = data.carrier.apiInterface;
          if (data.baseDetail.acceptablePackageTypeList) {
            v.channelBasicInfo.acceptablePackageTypeList = data.baseDetail.acceptablePackageTypeList.map(i => i.value);
          }
          let carrierShippingMethodPriceModel = data.carrierShippingMethodPriceModel;
          if (carrierShippingMethodPriceModel) {
            v.pricingParams.priceType = carrierShippingMethodPriceModel.priceType;
            v.freightDiscount = carrierShippingMethodPriceModel.freightDiscount;
            v.freightCurrency = carrierShippingMethodPriceModel.freightCurrency;
            v.freightDiscountType = carrierShippingMethodPriceModel.freightDiscountType;
            v.carrierShippingMethodPriceModelId = carrierShippingMethodPriceModel.carrierShippingMethodPriceModelId;
            if (carrierShippingMethodPriceModel.priceType === 3) {
              v.setCachePriceModelColumns(data.carrierShippingMethodPriceModelZoneList);
            }
            v.pricingParams.weightType = carrierShippingMethodPriceModel.weightType;
            if (carrierShippingMethodPriceModel.priceType === 3) { // 如果是分段续费，则去分段那里取计费方式
              v.pricingParams.subCostWay = data.carrierShippingMethodPriceModelZoneList[0].carrierShippingMethodSectionChargesList[0].priceType;
            }
          }
          v.carrierShippingMethodParmas = v.deepCopy(data.carrierShippingMethod);
          if (v.carrierShippingMethodParmas.arriveableType !== null && v.carrierShippingMethodParmas.arriveableType !== 0 && data.carrierShippingMethodPriceModelZoneList && data.carrierShippingMethodPriceModelZoneList.length > 0) {
            data.carrierShippingMethodPriceModelZoneList.forEach(i => {
              if (i.carrierShippingMethodPriceModelZoneCountryList) {
                i.countryTwoCodeList = i.carrierShippingMethodPriceModelZoneCountryList.map(j => {
                  return j.twoCode;
                });
              }
            });
            v.$nextTick(() => {
              let zoneList = data.carrierShippingMethodPriceModelZoneList;
              v.arriveableType = v.carrierShippingMethodParmas.arriveableType;
              v.data4 = zoneList;
              if (v.arriveableType === 1) {
                v.data5 = zoneList;
              } else if (v.arriveableType === 2) {
                v.data6 = zoneList;
              } else if (v.arriveableType === 3) {
                v.data7 = zoneList;
              }
            });
          } else {
            v.arriveableType = 1;
            v.data4 = v.data5; // data5 为默认值
          }
          v.cachePricingData = data.carrierShippingMethodPriceModelZoneList;

          // 交货方式的地址
          let carrierShippingMethodAddress = data.carrierShippingMethodAddress || [];
          // 交货方式的地址
          if (data.carrierShippingMethod) {
            let deliveryType = Number(data.carrierShippingMethod.deliveryType);
            v.deliveryMethodForm.deliveryType = deliveryType;
            v.deliveryMethodForm.deliveryMethod = getEnumName(v.enumData, 'DeliveryTypeEnum', deliveryType, 'number');
            v.deliveryMethodForm.courierFee = Number(data.carrierShippingMethod.domesticExpressFee) || null;
          }
          let deliveryAddressList = carrierShippingMethodAddress.filter((item) => {
            return item.addressType === 'delivery';
          });
          if (deliveryAddressList.length > 0) {
            let obj = deliveryAddressList[0];
            if (obj) {
              if (v.addressTemplateData.length > 0) {
                let newList = v.addressTemplateData.filter((ele) => {
                  return ele.ymsAddressTemplateId === obj.ymsAddressTemplateId;
                });
                if (newList && newList.length > 0) {
                  v.deliveryMethodForm.addressDetails = newList[0];
                  if (v.countrysData.length > 0) {
                    v.countrysData.map((talg) => {
                      if (talg.twoCode === newList[0].countryCode) {
                        v.deliveryMethodForm.addressDetails.countryCode = talg.cnName;
                      }
                    });
                  }
                }
              }
            }
          }
          v.$forceUpdate();
        }
      });
    },
    // 监听弹窗
    ownlogisticsChannelChange(value) {
      if (!value) {
        this.resetData();
      }
    },
    // 设置计费模型编辑弹窗的表格
    setCachePriceModelColumns(cData) {
      let v = this;
      v.cachePriceModelColumns = [];
      for (let i = 0; i < cData[0].carrierShippingMethodSectionChargesList.length; i++) {
        let item = cData[0].carrierShippingMethodSectionChargesList[i];
        let culumnItem = {
          align: 'center',
          minWidth: 230,
          renderHeader: (h, col) => {
            return h('div', [
              h('span', item.startWeight),
              h('span', {
                style: {
                  margin: '0 3px'
                }
              }, '-'),
              h('span', item.endWeight),
              h('span', {
                style: {
                  margin: '0 3px'
                }
              }, 'g')
            ]);
          },
          render: (h, params) => {
            if (item.priceType === 3) { // 编辑状态下，priceType等于3时返回结果
              return h('div', {
                style: {
                  padding: '8px 0'
                }
              }, [
                h('div', {
                  class: 'flexBox'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005268')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].firstWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ]), h('div', {
                  class: 'flexBox normalTop'
                }, [
                  h('span', {
                    style: {
                      color: 'red',
                      marginRight: '5px',
                      position: 'relative',
                      top: '8px'
                    }
                  }, '*'),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005270')),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-right': '5px'
                    }
                  }, v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeight),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin': '0 5px'
                    }
                  }, 'g'),
                  h('InputNumber', {
                    props: {
                      value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice,
                      min: 0,
                      max: 9999999,
                      size: 'small'
                    },
                    style: {
                      width: '60px',
                      marginTop: '3px'
                    },
                    on: {
                      'input': (val) => {
                        v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice = val;
                      }
                    }
                  }),
                  h('span', {
                    style: {
                      position: 'relative',
                      top: '6px',
                      'margin-left': '5px'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269'))
                ]), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'), h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].unitWeightPrice * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 2) { // 编辑状态下，priceType等于2时返回结果
              return h('div', [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '5px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '80%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }),
                h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'),
                  h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            } else if (item.priceType === 1) { // 编辑状态下，priceType等于1时返回结果
              return h('div', {
                class: 'flexBox'
              }, [
                h('span', {
                  style: {
                    color: 'red',
                    marginRight: '5px',
                    position: 'relative',
                    top: '10px'
                  }
                }, '*'),
                h('InputNumber', {
                  props: {
                    value: v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price,
                    max: 9999999,
                    min: 0
                  },
                  style: {
                    width: '75%'
                  },
                  on: {
                    'input': (val) => {
                      v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price = val;
                    }
                  }
                }),
                h('span', {
                  style: {
                    position: 'relative',
                    top: '6px',
                    'margin-left': '5px'
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005269') + '/g'), h('div', {
                  class: 'flexBox normalTop flexBoxJustContent'
                }, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005250') + '：'),
                  h('span', {
                    class: 'redColor'
                  }, Math.round((v.cachePricingData[params.index].carrierShippingMethodSectionChargesList[i].price * (v.freightDiscount === null
                    ? 100
                    : v.freightDiscount) / 100) * 100) / 100)
                ])
              ]);
            }
          }
        };
        v.cachePriceModelColumns.push(culumnItem);
      }
    },
    // 批量导入--导入运费模板
    batchImport() {
      this.$refs.importFreightTemplate.importForm.shippingMethodId = this.shippingMethodId;
      this.$refs.importFreightTemplate.initImportFreightTemplateData();
    },
    // 新增分区
    addPartition() {
      if (this.arriveableType === 2) {
        let lenght = this.data6.length + '';
        if (this.data4.length > 0) {
          this.data6 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data6.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data6));
      } else if (this.arriveableType === 3) {
        let lenght = this.data7.length + 1 + '';
        if (this.data4.length > 0) {
          this.data7 = JSON.parse(JSON.stringify(this.data4));
        }
        this.data7.push({
          'carrierShippingMethodPriceModelZoneId': null,
          'carrierShippingMethodSectionChargesList': [
            {
              'additionalFeeRate': 0,
              'carrierShippingMethodPriceModelZoneId': null,
              'carrierShippingMethodSectionChargesId': null,
              'endWeight': 0,
              'firstWeight': 0,
              'firstWeightPrice': 0,
              'operatingCost': 0,
              'price': 0,
              'priceCurrency': 'CNY',
              'priceType': 0,
              'registrationFee': 0,
              'sortNo': 0,
              'startWeight': 0,
              'unitWeight': 0,
              'unitWeightPrice': 0
            }
          ],
          'countryTwoCodeList': [],
          'priceType': 0,
          'volumeWeight': 0,
          'weightType': 0,
          'zoneName': lenght,
          carrierShippingMethodPriceModelZoneCountryList: []
        });
        this.data4 = JSON.parse(JSON.stringify(this.data7));
      }
    },
    // 计费模型编辑弹窗--保存按钮
    editOK(obj) {
      let v = this;
      if (obj) {
        v.data4[v.editIndex].carrierShippingMethodSectionChargesList = obj.cacheEditPriceModalData;
        v.data4[v.editIndex].volumeWeight = obj.pricingQuantityMode.volumeWeight;
        v.data4[v.editIndex].weightType = obj.pricingQuantityMode.weightType;
        v.data4[v.editIndex].priceType = obj.pricingQuantityMode.priceType;
        v.data4[v.editIndex].formula = obj.freightText;
        v.data4[v.editIndex].countryTwoCodeList = obj.choseCountryId;
        v.data4[v.editIndex].carrierShippingMethodPriceModelZoneCountryList = obj.countryData.filter(i => {
          if (obj.choseCountryId.indexOf(i.twoCode) > -1) {
            return i;
          }
        });
        let data = JSON.parse(JSON.stringify(v.data4));
        v.data4 = [];
        v.data4 = data;
      }
    },
    // 导入运费模板批量上传文件成功
    importFreightTemplateSuccess(res) {
      const v = this;
      if (res.data.code !== 0) {
        const text = publicExceptionCodes(res.data.code);
        const errorMsg = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005265');
        v.$Message.error(errorMsg);
        return false;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      // 2 覆盖原有数据, 1 国家相同覆盖不同追加
      const coveredType = res.coveredType;
      let data = res.data.datas.carrierShippingMethodPriceModelZones || [];
      const countryMap = new Map((v.countrysData || []).map(country => [country.twoCode, country]));
      data.forEach(i => {
        const zoneCountryList = i.carrierShippingMethodPriceModelZoneCountryList || [];
        if (zoneCountryList.length) {
          zoneCountryList.forEach(item => {
            Object.assign(item, {
              cnName: countryMap.get(item.twoCode)?.name || '',
              countryId: countryMap.get(item.twoCode)?.countryId || '',
              enName: countryMap.get(item.twoCode)?.enName || ''
            });
          });
          i.countryTwoCodeList = zoneCountryList.map(j => j.twoCode);
        }
        i.formula = processFreightText(i.priceType, false, true);
      });

      // 根据 coveredType 是否覆盖数据
      const handleData = (oldData) => coveredType === 2 ? data : mergeByCountriesStrict(oldData, data);
      // zoneName（默认区保留0，其余递增）
      const resetZoneName = (list = [], keepZero = false) => {
        let index = keepZero ? 1 : 0;
        return list.map(item => {
          if (keepZero && item.zoneName === '0') return item;
          return {...item, zoneName: String(index++)};
        });
      };

      switch (v.arriveableType) {
        // 1 全球可达运费相同
        case 1:
          let newData = data.flatMap(item => item.carrierShippingMethodSectionChargesList || []);
          v.data5.map((item) => {
            item.carrierShippingMethodSectionChargesList = newData;
            item.priceType = data[0]?.priceType;
            item.formula = data[0]?.formula;
            item.volumeWeight = data[0]?.volumeWeight;
            item.weightType = data[0]?.weightType;
          });
          v.data4 = [...v.data5];
          break;
        // 2 全球可达运费不同
        case 2:
          const base = v.data6.filter(i => i.zoneName === '0');
          const other = v.data6.filter(i => i.zoneName !== '0');
          let arr2 = coveredType === 2 ? [...base, ...data] : [...base, ...mergeByCountriesStrict(other, data)];
          const nonDefault = arr2.filter(i => i.zoneName !== '0');
          v.data6 = [...base, ...resetZoneName(nonDefault, true)];
          v.data4 = [...v.data6];
          break;
        // 3 非全球可达
        case 3:
          let arr3 = handleData(v.data7);
          v.data7 = resetZoneName(arr3, true);
          v.data4 = [...v.data7];
          break;
      }
      v.$refs['importFreightTemplate'].importFreightTemplateModal = false;
    },
    // 获取国家的数据
    getAllCountryName(loading) {
      let v = this;
      getRegionalRcountriesData(loading).then((data) => {
        v.$refs['billingModelEditing'].countryCodesName = data;
      });
    },
    // 从其他渠道引用
    channelCitation() {
      this.$refs.channelReference.channelModal = true;
      let selectProvider = this.modalData.carrier.carrierId;
      this.$refs.channelReference.selectProvider = selectProvider;
      this.$refs.channelReference.logisticsChannel = this.modalData.carrierShippingMethod.shippingMethodId;
      this.$refs.channelReference.ChangeSelectProvider(selectProvider);
    },
    // 获取从其他渠道引用的物流商数据
    GetQuotingLogisticsData(loading) {
      this.$refs.channelReference.selectProviderList = [];
      this.axios.get(api.get_carrier_queryForEnableCarriers, {loading: loading}).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data.length > 0) {
            data.map((item) => {
              this.$refs.channelReference.selectProviderList.push({
                id: item.carrierId,
                name: item.carrierName
              });
            });
          }
        }
      });
    },
    // 引用其他物流渠道
    saveChannel(data) {
      if (data) {
        this.arriveableType = data.arriveableType;
        let list = data.list;
        if (list && list.length > 0) {
          list.forEach(i => {
            i.carrierShippingMethodPriceModelId = this.carrierShippingMethodPriceModelId;
            if (i.carrierShippingMethodPriceModelZoneCountryList) {
              i.countryTwoCodeList = i.carrierShippingMethodPriceModelZoneCountryList.map(j => {
                return j.twoCode;
              });
            }
          });
          this.data4 = [];
          if (this.arriveableType === 1) {
            this.data5 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data5));
          } else if (this.arriveableType === 2) {
            this.data6 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data6));
          } else if (this.arriveableType === 3) {
            this.data7 = list;
            this.data4 = JSON.parse(JSON.stringify(this.data7));
          }
        }
      }
    },
    // 获取设置/编辑/新增自定义物流渠道弹窗的表单参数
    handleSubmit(name) {
      let v = this;
      let result = true;
      v.$refs[name].validate(function (valid) {
        result = !!valid;
      });
      return result;
    },
    //自有物流渠道--保存按钮
    setShippingMethod() {
      let v = this;
      let pos = [];
      let obj = {};
      obj.shippingMethodId = v.shippingMethodId;
      obj.carrierShippingMethodPriceModel = {};
      obj.carrierShippingMethodPriceModel.priceType = v.pricingParams.priceType;
      obj.carrierShippingMethodPriceModel.weightType = v.pricingParams.weightType;
      obj.carrierShippingMethodPriceModel.freightDiscount = v.freightDiscount;
      obj.carrierShippingMethodPriceModel.freightCurrency = v.freightCurrency;
      obj.carrierShippingMethodPriceModel.freightDiscountType = v.freightDiscountType;
      obj.carrierShippingMethodPriceModel.carrierShippingMethodPriceModelId = v.carrierShippingMethodPriceModelId;
      obj.carrierShippingMethodPriceModelZoneList = v.data4;
      obj.arriveableType = v.arriveableType; // 邮寄方式  可达类型(1全球可达运费相同2全球可达运费不同3非全球可达) ,
      if (obj.carrierShippingMethodPriceModelZoneList) {
        let valid = obj.carrierShippingMethodPriceModelZoneList.some(i => {
          return i.zoneName !== '0' && (!i.countryTwoCodeList || i.countryTwoCodeList.length === 0);
        });
        if (valid) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005264'));
          return;
        }

        obj.carrierShippingMethodPriceModelZoneList.forEach((n, i) => {
          if (n.carrierShippingMethodSectionChargesList) {
            n.carrierShippingMethodSectionChargesList.forEach((m, t) => {
              pos.push(m);
            });
          }
        });
      }
      obj.carrierShippingMethodSectionCharges = pos;
      /* 添加基础信息 */
      obj.baseDetail = v.channelBasicInfo;
      obj.baseDetail.acceptablePackageTypeList = v.channelBasicInfo.acceptablePackageTypeList;
      obj.baseDetail.receiveTypeList = [];
      obj.baseDetail.arriveableType = v.arriveableType; // 邮寄方式  可达类型(1全球可达运费相同2全球可达运费不同3非全球可达)
      obj.updateApplicationScopeBo = {
        goodsTagList: [],
        skuList: [],
        warehouseIdList: []
      };
      v.axios.put(api.put_ymsCarrierShippingMethod_update, JSON.stringify(obj),
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.ownLogisticsChannelModal = false;
          v.resetData();
          v.$emit('updateData', true);
        }
      });
    },
    // 重置数据
    resetData() {
      let v = this;
      v.arriveableType = 1;
      // 基础信息
      v.channelBasicInfo = {
        acceptableCityList: null,
        acceptableTypeList: [],
        carrierShippingMethodCode: '',
        carrierShippingMethodName: '',
        minEfficiency: 0,
        maxEfficiency: 0,
        maxLength: 0,
        maxWidth: 0,
        maxHeight: 0,
        minWeight: 0,
        maxWeight: 0,
        maxPerimeter: 0,
        maxDimensionsLength: 0,
        minVolume: 0,
        maxVolume: 0,
        acceptablePackageTypeList: '',
        isSupportInterfaceTransferBill: 0,
        arriveableType: '1',
        remark: ''
      };
    },
    // 整合通达国家数据
    getPricingReachStateData(reachStateArr) {
      let arr = [];
      if (reachStateArr) { // reachStateArr 不为null
        for (let i = 0; i < reachStateArr.length; i++) {
          let item = reachStateArr[i];
          arr.push(item.cnName);
          if (i === reachStateArr.length - 1) {
            return arr.toString();
          }
        }
      }
    },
    // 设置表格列
    setTableColumns(type) {
      let v = this;
      if (type === 1) {
        v.pricingModelColumns = v.pricingModelCommonColumns;
      } else if (type === 2) {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.pricingModelContinuedHeavyColumns);
          v.pricingModelColumns = arr;
        });
      } else {
        v.getNewArr(v.pricingModelCommonColumns).then(arr => {
          arr.splice(2, 1, ...v.cachePriceModelColumns);
          v.pricingModelColumns = arr;
        });
      }
    },
    // 浅拷贝数组
    getNewArr(arr) {
      let newArr = [];
      return new Promise(resolve => {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          newArr.push(item);
          if (i === arr.length - 1) {
            resolve(newArr);
          }
        }
      });
    },
    // 获取履约方式名称
    getPerformanceMethodName(value) {
      const item = PERFORMANCEMETHODDATA.find(item => item.value === value);
      return item ? item.name : '';
    }
  },
  watch: {
    arriveableType: {
      handler(newVal) {
        this.data4 = [];
        if (newVal === 1) {
          this.data4 = JSON.parse(JSON.stringify(this.data5));
        } else if (newVal === 2) {
          this.data4 = JSON.parse(JSON.stringify(this.data6));
        } else if (newVal === 3) {
          this.data4 = JSON.parse(JSON.stringify(this.data7));
        }
      },
      deep: true,
      immediate: true
    },
    'pricingParams.priceType': {
      handler(n, o) {
        if (n !== o) {
          this.setTableColumns(n);
        }
      }
    },
  },
  components: {
    importFreightTemplateModal,
    channelReferenceModal,
    billingModelEditingModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .ownlogisticsChannelStyle {
  .ivu-card {
    margin: 10px 10px 20px 10px;

    .title_box {
      color: #333;
      font-size: 17px;
      font-weight: bold;
    }
  }

  .ivu-form {
    .ivu-form-item-label {
      font-size: 14px;
      font-weight: bold;
    }

    .ivu-form-item-content {
      line-height: 34px;
    }

    .ivu-form-item {
      margin: 0;
    }
  }

  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .basic_item {
    line-height: inherit;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .basic_title {
      min-width: initial;
      display: inline-block;
    }

    .basic_txt {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>